import { render, staticRenderFns } from "./cowsNotConfirmedPregnant.vue?vue&type=template&id=ca0e58c4&scoped=true&"
import script from "./cowsNotConfirmedPregnant.vue?vue&type=script&lang=js&"
export * from "./cowsNotConfirmedPregnant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0e58c4",
  null
  
)

export default component.exports